
const state = {
	// screen type
	screen: null,
	// flag : モーダル背景
	activeModalCover: false,
	activeVideoChatModalCover: false,
	// flag : ダイアログ背景
	activeDialogCover: false,
	// flag : SCL背景
	activeSclCover: false,
	// flag : アカウントボックス
	activeAccount: false,
	// flag : ドロワーメニュー（SP）
	activeDrawer: false,
	// flag : グローバルメニューの展開（PC）
	activeGlobalMenu: true
}

const getters = {
  get: state => state,
  // screen
  isSmartPhone: state => state.screen === 'SP',
  isTablet: state => state.screen === 'TB',
  isDisplay: state => state.screen === 'PC'
}

const actions = {
	// screen
	changeScreen ({commit}, type) {
		commit('setScreen', type)
	},
	// モーダル背景
	showModalCover ({commit}) {
		commit('setModalCover', true)
	},
	showActiveModalCover ({commit}) {
		commit('setActiveModalCover', true)
	},
	hideModalCover ({commit}) {
		commit('setModalCover', false)
	},
	hideActiveModalCover ({commit}) {
		commit('setActiveModalCover', false)
	},
	// ダイアログ背景
	showDialogCover ({commit}) {
		commit('setDialogCover', true)
	},
	hideDialogCover ({commit}) {
		commit('setDialogCover', false)
	},
	// SCL背景
	showSclCover ({commit}) {
		commit('setSclCover', true)
	},
	hideSclCover ({commit}) {
		commit('setSclCover', false)
	},
	// アカウントボックス
	showAccount ({commit}) {
		commit('setAccount', true)
	},
	hideAccount ({commit}) {
		commit('setAccount', false)
	},
	// ドロワーメニュー（SP）
	showDrawer ({commit}) {
		commit('setDrawer', true)
	},
	hideDrawer ({commit}) {
		commit('setDrawer', false)
	},
	// グローバルメニューの展開（PC）
	toggleGlobalMenu ({commit}) {
		commit('setGlobalMenu', !state.activeGlobalMenu)
	}
}

const mutations = {
	setScreen (state, type) {
		state.screen = type
	},
	// flag
	setModalCover (state, flag) {
		state.activeModalCover = flag
	},
	setActiveModalCover (state, flag) {
		state.activeVideoChatModalCover = flag
	},
	setDialogCover (state, flag) {
		state.activeDialogCover = flag
	},
	setSclCover (state, flag) {
		state.activeSclCover = flag
	},
	setAccount (state, flag) {
		state.activeAccount = flag
	},
	setDrawer (state, flag) {
		state.activeDrawer = flag
	},
	setGlobalMenu (state, flag) {
		state.activeGlobalMenu = flag
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
